import { render, staticRenderFns } from "./CmgMemberLoyaltyRewards.vue?vue&type=template&id=7b1aa644&scoped=true&lang=pug&"
import script from "./cmg-member-loyalty-rewards.ts?vue&type=script&lang=ts&"
export * from "./cmg-member-loyalty-rewards.ts?vue&type=script&lang=ts&"
import style0 from "./CmgMemberLoyaltyRewards.vue?vue&type=style&index=0&id=7b1aa644&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b1aa644",
  null
  
)

export default component.exports